import { NgForm } from '@angular/forms';

/**
 * This method is used to get the first field with the error in the given invalid form
 *
 * @param form
 *    The form whose error field is identified
 *
 * @return Name of the invalid field
 */
export function getFirstErrorControl(form: NgForm): string {
  const controls = form.form.controls;
  return Object.keys(controls).find((c) => controls[ c ].invalid);
}

export function makeHeader(name: string, id: string | number): string {
  return name + ' (' + id + ')';
}
